import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=82668850&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=ts"
export * from "./ChatMessages.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=82668850&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82668850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82668850')) {
      api.createRecord('82668850', component.options)
    } else {
      api.reload('82668850', component.options)
    }
    module.hot.accept("./ChatMessages.vue?vue&type=template&id=82668850&scoped=true", function () {
      api.rerender('82668850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat-components/ChatMessages.vue"
export default component.exports